import { StemType } from '@arpeggi/shared'
import { Dispatch, FC, SetStateAction } from 'react'
import { CenteredRow, Row, VerticalCenteredRow } from '../../core/Components'
import { StudioTab } from '../controls/common'
import { SelectedTrackContainerTabs } from '../SelectedTrackContainer'
import ClipEditorControls from './ClipEditorControls'

// Whether to show the instrument tab. Should show it once we enable the more powerful Instrument UI.
const SHOW_INSTRUMENT_TAB = false

interface STCLabelProps {
  stemType: string | number
  isRemixed: boolean
  isDrums: boolean
  selectedTab: number
  setSelectedTab: Dispatch<SetStateAction<number>>
}
const STCLabel: FC<STCLabelProps> = ({
  stemType,
  isRemixed,
  isDrums,
  selectedTab,
  setSelectedTab
}) => (
  <CenteredRow style={{ flex: '1', fontSize: '14px' }}>
    {isRemixed && stemType !== StemType.AUDIO ? (
      <VerticalCenteredRow>
        <img src="/static/icons/studio_eye.svg" style={{ marginRight: '7px', width: '20px' }} />
        View only
      </VerticalCenteredRow>
    ) : (
      <>
        {stemType === StemType.AUDIO && <ClipEditorControls />}
        {SHOW_INSTRUMENT_TAB && (
          <Row verticalCenter horizontalCenter>
            <StudioTab
              active={selectedTab === SelectedTrackContainerTabs.pianoRoll}
              onClick={() => setSelectedTab(SelectedTrackContainerTabs.pianoRoll)}
            >
              {stemType === StemType.DRUMS && 'Drum Sequencer'}
              {stemType === StemType.INSTRUMENT && 'Piano Roll'}
              {stemType === StemType.AUDIO && 'Clip'}
            </StudioTab>
            {stemType === StemType.INSTRUMENT && (
              <StudioTab
                active={selectedTab === SelectedTrackContainerTabs.instrument}
                onClick={() => setSelectedTab(SelectedTrackContainerTabs.instrument)}
              >
                Instrument
              </StudioTab>
            )}
          </Row>
        )}
      </>
    )}
  </CenteredRow>
)

export default STCLabel
